import {takeLatest, put, all, call} from 'redux-saga/effects';
import {successToast} from '../actions';
import * as AC from '../actions/actionTypes';
import {
  addBuildingApi,
  deleteBuildingApi,
  editBuildingApi,
  getAllBuildingsApi,
  getBuildingDetailsApi,
  getBuildingsApi,
  getBuldingsGraphApi,
} from '../api/buildings.service';
import history from '../routes/history';
import {errorHandler} from '../utils/errorHandler';

function* getBuildingsSaga(fn) {
  try {
    const response = yield call(getBuildingsApi, fn.filters);
    yield put({
      type: AC.GET_BUILDINGS_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_BUILDINGS_FAILED);
  }
}

function* getAllBuildingsSaga(fn) {
  try {
    const response = yield call(getAllBuildingsApi, fn.filters);
    yield put({
      type: AC.GET_ALL_BUILDINGS_SUCCEED,
      payload: response.data, // assuming the API returns the data you need
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_ALL_BUILDINGS_FAILED);
  }
}


function* getBuildingDetailsSaga(fn) {
  try {
    const response = yield call(getBuildingDetailsApi, fn.id);
    yield put({type: AC.GET_BUILDING_DETAILS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_BUILDING_DETAILS_FAILED);
  }
}

function* addBuildingSaga(fn) {
  try {
    const response = yield call(addBuildingApi, fn.payload);
    yield put({type: AC.ADD_BUILDING_SUCCEED, payload: response.data});
    yield put(successToast('Complex created successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.ADD_BUILDING_FAILED);
  }
}

function* editBuildingSaga(fn) {
  try {
    const response = yield call(editBuildingApi, fn.payload);
    yield put({type: AC.EDIT_BUILDING_SUCCEED, payload: response.data});
    yield put(successToast('Complex edited successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.EDIT_BUILDING_FAILED);
  }
}

function* deleteBuildingSaga(fn) {
  try {
    const response = yield call(deleteBuildingApi, fn.id);
    yield put({type: AC.DELETE_BUILDING_SUCCEED, payload: response.data});
    yield put(successToast('Complex deleted successfully!'));
    history.back();
  } catch (e) {
    yield errorHandler(e, AC.DELETE_BUILDING_FAILED);
  }
}

function* getBuildingsGraphSaga() {
  try {
    const response = yield call(getBuldingsGraphApi);
    yield put({type: AC.GET_BUILDINGS_GRAPH_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_BUILDINGS_GRAPH_FAILED);
  }
}

function* actionWatcher() {
  yield takeLatest(
    [AC.GET_BUILDINGS_REQUEST, AC.ADD_BUILDING_SUCCEED],
    getBuildingsSaga,
  );
  yield takeLatest(AC.GET_BUILDING_DETAILS_REQUEST, getBuildingDetailsSaga);
  yield takeLatest(AC.GET_ALL_BUILDINGS_REQUEST, getAllBuildingsSaga)
  yield takeLatest(AC.ADD_BUILDING_SUCCEED, getBuildingsSaga);
  yield takeLatest(AC.ADD_BUILDING_SUCCEED, getBuildingsSaga);
  yield takeLatest(AC.ADD_BUILDING_REQUEST, addBuildingSaga);
  yield takeLatest(AC.EDIT_BUILDING_REQUEST, editBuildingSaga);
  yield takeLatest(AC.DELETE_BUILDING_REQUEST, deleteBuildingSaga);
  yield takeLatest(AC.GET_BUILDINGS_GRAPH_REQUEST, getBuildingsGraphSaga);
}

export default function* buildingsSaga() {
  yield all([actionWatcher()]);
}
